import { useEffect, useMemo, useState } from 'react';

import { Quote } from '@meterup/connect-api';

// Utils
import { onlyUnique } from '../utils/Array.utils';

// A hooks to keep quotes logic / filtering
export default function useProvidersFilter(quotes: Quote[]) {
  const quotesByProvider = useMemo(
    () =>
      [...quotes]
        .sort((a, b) => (a.monthlyFeeCents ?? 0) - (b.monthlyFeeCents ?? 0))
        .reduce<Record<string, Quote[]>>((acc, q) => {
          const key = q?.provider?.name || '';
          (acc[key] ??= []).push(q);
          return acc;
        }, {}),
    [quotes],
  );

  // Contract Length - All
  const allProviders = useMemo(() => Object.keys(quotesByProvider), [quotesByProvider]);

  // Contract Length - Currently selected (default: all)
  const [currentProviders, setCurrentProviders] = useState(allProviders);

  // Contract Length - setstate
  useEffect(() => {
    setCurrentProviders(allProviders);
  }, [allProviders]);

  // Contract Length - User event change
  const onProvidersChange = (providerName: string, checked: boolean) => {
    let newCurrentProviders = currentProviders;
    if (checked) {
      newCurrentProviders.push(providerName);
    } else {
      newCurrentProviders = newCurrentProviders.filter((item) => item !== providerName);
    }
    setCurrentProviders(newCurrentProviders.filter(onlyUnique));
  };

  const resetProvidersFilter = () => {
    setCurrentProviders(allProviders);
  };

  return {
    quotesByProvider,
    allProviders,
    currentProviders,
    onProvidersChange,
    resetProvidersFilter,
  };
}
